import React, { useEffect, useRef } from "react";
import CreateSupplier from "../../Pages/Supplier/CreateSupplier";

const CreateSupplierModal = ({
    modal,
    goback,
    currentItem,
    refetchSuppliers,
}) => {
    const closeModalButtonRef = useRef(null);
    const handleCloseModal = () => {
        if (closeModalButtonRef.current) {
            closeModalButtonRef.current.click();
        }
    };
    useEffect(() => {
        return () => {
            const backdrop = document.querySelector(".modal-backdrop");
            if (backdrop) {
                backdrop.remove();
                document.body.classList.remove("modal-open");
                document.body.style = "";
            }
        };
    }, []);
    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id={`create-supplier-modal`}
            aria-modal
        >
            <div className="modal-dialog modal-lg" role="document">
                <div className="modal-content">
                    <button
                        className="close"
                        data-bs-dismiss="modal"
                        ref={closeModalButtonRef}
                    >
                        <em
                            className="icon ni ni-cross"
                            aria-hidden="true"
                        ></em>
                    </button>
                    <div className="modal-header">
                        <h5 className="modal-title">Supplier</h5>
                    </div>
                    <div className="modal-body">
                        <CreateSupplier
                            modal={modal}
                            goback={goback}
                            currentItem={currentItem}
                            refetchSuppliers={refetchSuppliers}
                            handleCloseModal={handleCloseModal}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CreateSupplierModal;
